module.exports = __webpack_public_path__ + "static/expereince-e9178aa0b8824e0fb90a784c9b992bb5.svg";